import {
  useExperimentsEligibleProps,
  type FeatureFlagProviderProps,
} from '@seek/candidate-feature-flag';

import { appName, version } from 'src/config';
import { featureFlagsToFetch } from 'src/config/featureFlags';
import { useAnalyticsFacade } from 'src/modules/AnalyticsFacade';
import { getUserAgent } from 'src/modules/chalice-user-agent/isomorphic-useragent';
import { useSelector } from 'src/store/react';
import { selectSolId } from 'src/store/selectors';

export const useFeatureFlagProviderProps = (): Omit<
  FeatureFlagProviderProps,
  'children'
> => {
  const solId = useSelector(selectSolId) || '';

  return {
    featureFlags: featureFlagsToFetch,
    userAgent: getUserAgent(),
    solId,
    experimentsKeysAndTrackingNumbers: [],
    customContext: {
      applicationContext: {
        key: solId,
        namespace: appName,
        build: version,
        version,
      },
    },
  };
};

export const InitialiseExperiments = () => {
  const analyticsFacade = useAnalyticsFacade();
  const { tealiumEligibleProps } = useExperimentsEligibleProps();
  if (tealiumEligibleProps?.length) {
    analyticsFacade.setExperimentEligible(tealiumEligibleProps);
  }

  return null;
};
